import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getReviews } from '../lib/api';

function Resenas() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getReviews()
      .then((data) => setReviews(data.reviews))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Seo title="Reseñas" description="Reseñas de libros: opiniones honestas, valoración, pros y contras." />
      <h1>Reseñas</h1>
      <p className="page__intro">Opiniones honestas sobre los libros leídos, con valoración, pros y contras.</p>

      {!loading && reviews.length === 0 && (
        <p className="empty-state">Todavía no hay reseñas publicadas.</p>
      )}
      <div className="card-grid">
        {reviews.map((review) => (
          <Link key={review.id} to={`/resenas/${review.slug}`} className="content-card">
            {review.cover_url && <img src={review.cover_url} alt={review.title} />}
            <div className="content-card__body">
              <span className="content-card__category">Reseña</span>
              <h3 className="content-card__title">{review.title}</h3>
              {review.book_title && <p className="content-card__excerpt">{review.book_title}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Resenas;
